// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import API_BASE_URL from "../config";

// // import React, { useState, useEffect } from "react";
// // import axios from "axios";

// // const DriverShift = () => {
// //   const [formData, setFormData] = useState({
// //     driverId: "",
// //     shiftType: "",
// //     referBy: "",
// //     state: "",
// //     shiftA: false,
// //     shiftB: false,
// //   });

// //   useEffect(() => {
// //     if (formData.shiftType === "24-Hours Double Shift") {
// //       const currentHour = new Date().getHours();
// //       if (currentHour >= 6 && currentHour < 18) {
// //         setFormData((prev) => ({ ...prev, shiftA: true, shiftB: false }));
// //       } else {
// //         setFormData((prev) => ({ ...prev, shiftA: false, shiftB: true }));
// //       }
// //     } else {
// //       setFormData((prev) => ({ ...prev, shiftA: false, shiftB: false }));
// //     }
// //   }, [formData.shiftType]);

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;
// //     setFormData((prev) => ({ ...prev, [name]: value }));
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     try {
// //       const response = await axios.post(API_BASE_URL + "/onboarding/driver-addon-data", formData);
// //       alert(response.data.message);
// //       setFormData({ driverId: "", shiftType: "", referBy: "", state: "", shiftA: false, shiftB: false });
// //     } catch (error) {
// //       alert("Error: " + (error.response?.data?.message || error.message));
// //     }
// //   };

// //   return (
// //     <div style={{ padding: "20px", marginLeft:"20%" }}>
// //       <h2>Driver Form</h2>
// //       <form onSubmit={handleSubmit}>
// //         <label>Driver ID: </label>
// //         <input type="text" name="driverId" value={formData.driverId} onChange={handleChange} required />
// //         <br />

// //         <label>Shift Type: </label>
// //         <select name="shiftType" value={formData.shiftType} onChange={handleChange} required>
// //           <option value="">Select Shift Type</option>
// //           <option value="12-Hours Shift">12-Hours Shift</option>
// //           <option value="24-Hours Single Shift">24-Hours Single Shift</option>
// //           <option value="24-Hours Double Shift">24-Hours Double Shift</option>
// //           <option value="Trip-Based">Trip-Based</option>
// //         </select>
// //         <br />

// //         <label>Refer By: </label>
// //         <input type="text" name="referBy" value={formData.referBy} onChange={handleChange} required />
// //         <br />

// //         <label>State: </label>
// //         <input type="text" name="state" value={formData.state} onChange={handleChange} required />
// //         <br />

// //         {/* Show assigned shift when Double Shift is selected */}
// //         {formData.shiftType === "24-Hours Double Shift" && (
// //           <p>Assigned Shift: {formData.shiftA ? "Shift A (6 AM - 6 PM)" : "Shift B (6 PM - 6 AM)"}</p>
// //         )}

// //         <button type="submit">Submit</button>
// //       </form>
// //     </div>
// //   );
// // };

// // export default DriverShift;



// const DriverShift = () => {
//   const [formData, setFormData] = useState({
//     driverId: "",
//     shiftType: "",
//     referBy: "",
//     state: "",
//     shiftA: false,
//     shiftB: false,
//   });

//   useEffect(() => {
//     if (formData.shiftType === "24-Hours Double Shift") {
//       const currentHour = new Date().getHours();
//       if (currentHour >= 6 && currentHour < 18) {
//         setFormData((prev) => ({ ...prev, shiftA: true, shiftB: false }));
//       } else {
//         setFormData((prev) => ({ ...prev, shiftA: false, shiftB: true }));
//       }
//     } else {
//       setFormData((prev) => ({ ...prev, shiftA: false, shiftB: false }));
//     }
//   }, [formData.shiftType]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(API_BASE_URL + "/onboarding/driver-addon-data", formData);
//       alert(response.data.message);
//       setFormData({ driverId: "", shiftType: "", referBy: "", state: "", shiftA: false, shiftB: false });
//     } catch (error) {
//       alert("Error: " + (error.response?.data?.message || error.message));
//     }
//   };

//   return (
//     <div className="sendo-page">
//       <div style={{ backgroundColor: '#fff', padding: '40px', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', width: '400px' }}>
//         <h2 style={{ color: '#333', marginBottom: '20px' }}>Driver Form</h2>
//         <form onSubmit={handleSubmit}>
//           <label style={labelStyle}>Driver ID:</label>
//           <input style={inputStyle} type="text" name="driverId" value={formData.driverId} onChange={handleChange} required />

//           <label style={labelStyle}>Shift Type:</label>
//           <select style={inputStyle} name="shiftType" value={formData.shiftType} onChange={handleChange} required>
//             <option value="">Select Shift Type</option>
//             <option value="12-Hours Shift">12-Hours Shift</option>
//             <option value="24-Hours Single Shift">24-Hours Single Shift</option>
//             <option value="24-Hours Double Shift">24-Hours Double Shift</option>
//             <option value="Trip-Based">Trip-Based</option>
//           </select>

//           <label style={labelStyle}>Refer By:</label>
//           <input style={inputStyle} type="text" name="referBy" value={formData.referBy} onChange={handleChange} required />

//           <label style={labelStyle}>State:</label>
//           <input style={inputStyle} type="text" name="state" value={formData.state} onChange={handleChange} required />

//           {formData.shiftType === "24-Hours Double Shift" && (
//             <p style={{ color: '#007bff', marginTop: '10px' }}>
//               Assigned Shift: {formData.shiftA ? "Shift A (6 AM - 6 PM)" : "Shift B (6 PM - 6 AM)"}
//             </p>
//           )}

//           <button style={buttonStyle} type="submit">Submit</button>
//         </form>
//       </div>
//     </div>
//   );
// };

// const inputStyle = {
//   width: '100%',
//   padding: '10px',
//   marginBottom: '15px',
//   borderRadius: '8px',
//   border: '1px solid #ccc',
//   fontSize: '14px',
// };

// const labelStyle = {
//   fontWeight: 'bold',
//   marginBottom: '5px',
//   display: 'block',
// };

// const buttonStyle = {
//   backgroundColor: '#007bff',
//   color: '#fff',
//   padding: '12px 20px',
//   border: 'none',
//   borderRadius: '8px',
//   cursor: 'pointer',
//   fontSize: '16px',
//   width: '100%',
// };

// export default DriverShift;
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "../config";

const DriverShift = () => {
  const [formData, setFormData] = useState({
    driverId: "",
    shiftType: "",
    referBy: "",
    state: "",
    shiftA: false,
    shiftB: false,
  });

  useEffect(() => {
    if (formData.shiftType === "24-Hours Double Shift") {
      const currentHour = new Date().getHours();
      if (currentHour >= 6 && currentHour < 18) {
        setFormData((prev) => ({ ...prev, shiftA: true, shiftB: false }));
      } else {
        setFormData((prev) => ({ ...prev, shiftA: false, shiftB: true }));
      }
    } else {
      setFormData((prev) => ({ ...prev, shiftA: false, shiftB: false }));
    }
  }, [formData.shiftType]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleClear = () => {
    setFormData({ driverId: "", shiftType: "", referBy: "", state: "", shiftA: false, shiftB: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(API_BASE_URL + "/onboarding/driver-addon-data", formData);
      alert(response.data.message);
      handleClear();
    } catch (error) {
      alert("Error: " + (error.response?.data?.message || error.message));
    }
  };

  const s = {
    container: {
      fontFamily: "Arial, sans-serif",
      marginLeft: "278px",
      marginRight: "10px",
      backgroundColor: "#ffffff",
      color: "#000000",
      minHeight: "100vh",
    },
    pageHeader: {
      backgroundColor: "#FFC107",
      padding: "16px 24px",
      marginBottom: "0px",
    },
    pageHeaderText: {
      fontSize: "22px",
      fontWeight: "700",
      color: "#000000",
      letterSpacing: "1px",
      textTransform: "uppercase",
      margin: 0,
    },
    contentBody: {
      padding: "24px",
    },
    sectionTitle: {
      fontSize: "15px",
      fontWeight: "700",
      color: "#000000",
      marginBottom: "4px",
    },
    sectionDivider: {
      border: "none",
      borderTop: "2px solid #FFC107",
      marginBottom: "16px",
    },
    formGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
      gap: "16px",
      marginBottom: "24px",
    },
    fieldGroup: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    label: {
      fontSize: "13px",
      fontWeight: "700",
      color: "#000000",
    },
    input: {
      width: "100%",
      padding: "8px 10px",
      border: "1.5px solid #000000",
      borderRadius: "0",
      fontSize: "13px",
      backgroundColor: "#ffffff",
      color: "#000000",
      outline: "none",
      boxSizing: "border-box",
    },
    select: {
      width: "100%",
      padding: "8px 10px",
      border: "1.5px solid #000000",
      borderRadius: "0",
      fontSize: "13px",
      backgroundColor: "#ffffff",
      color: "#000000",
      outline: "none",
      boxSizing: "border-box",
      cursor: "pointer",
    },
    shiftNote: {
      fontSize: "13px",
      fontWeight: "700",
      color: "#000000",
      backgroundColor: "#fffde7",
      border: "1.5px solid #FFC107",
      padding: "8px 12px",
      marginBottom: "16px",
    },
    buttonRow: {
      display: "flex",
      gap: "12px",
      marginTop: "8px",
    },
    submitButton: {
      padding: "8px 28px",
      backgroundColor: "#FFC107",
      color: "#000000",
      border: "none",
      borderRadius: "0",
      cursor: "pointer",
      fontWeight: "700",
      fontSize: "13px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
    clearButton: {
      padding: "8px 28px",
      backgroundColor: "#000000",
      color: "#ffffff",
      border: "none",
      borderRadius: "0",
      cursor: "pointer",
      fontWeight: "700",
      fontSize: "13px",
      textTransform: "uppercase",
      letterSpacing: "0.5px",
    },
  };

  return (
    <div style={s.container}>
      {/* Yellow header bar */}
      <div style={s.pageHeader}>
        <h1 style={s.pageHeaderText}>Driver Shift</h1>
      </div>

      <div style={s.contentBody}>
        <div style={s.sectionTitle}>Shift Details</div>
        <hr style={s.sectionDivider} />

        <form onSubmit={handleSubmit}>
          <div style={s.formGrid}>
            <div style={s.fieldGroup}>
              <label style={s.label}>Driver ID:</label>
              <input
                style={s.input}
                type="text"
                name="driverId"
                value={formData.driverId}
                onChange={handleChange}
                required
              />
            </div>

            <div style={s.fieldGroup}>
              <label style={s.label}>Shift Type:</label>
              <select
                style={s.select}
                name="shiftType"
                value={formData.shiftType}
                onChange={handleChange}
                required
              >
                <option value="">Select Shift Type</option>
                <option value="12-Hours Shift">12-Hours Shift</option>
                <option value="24-Hours Single Shift">24-Hours Single Shift</option>
                <option value="24-Hours Double Shift">24-Hours Double Shift</option>
                <option value="Trip-Based">Trip-Based</option>
              </select>
            </div>

            <div style={s.fieldGroup}>
              <label style={s.label}>Refer By:</label>
              <input
                style={s.input}
                type="text"
                name="referBy"
                value={formData.referBy}
                onChange={handleChange}
                required
              />
            </div>

            <div style={s.fieldGroup}>
              <label style={s.label}>State:</label>
              <input
                style={s.input}
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          {formData.shiftType === "24-Hours Double Shift" && (
            <div style={s.shiftNote}>
              Assigned Shift: {formData.shiftA ? "Shift A (6 AM - 6 PM)" : "Shift B (6 PM - 6 AM)"}
            </div>
          )}

          <div style={s.buttonRow}>
            <button type="button" onClick={handleClear} style={s.clearButton}>Clear</button>
            <button type="submit" style={s.submitButton}>Submit</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DriverShift;